import React from "react";
import Moment from 'react-moment'

const History = ({ item }) => {
	return (
		<div className="table__row py-1 d-md-flex justify-content-between">
			<div className="flex-shrink-0">
				<p className="fz--16 fw--500">{item.name ? item.name : `${item.referred.firstName} ${item.referred.lastName}`}</p>
				<p className="fz--14 pt-1">
					{" "}
					<Moment format="DD,MMM YYYY">{item.createdAt}</Moment>
				</p>
			</div>
			{item?.user ? (
				<p className="pt-2 pt-md-0 fw--600 color--accent">Invitation sent</p>
			) : (
				<p className="pt-2 pt-md-0 fw--600 color--success">20%</p>
			)}
		</div>
	);
};

export default History;
